import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material';

export default <Components<Theme>>{};
